// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__B1vOC","success":"Badge_success__vW9Nn","warn":"Badge_warn__c40DE","info":"Badge_info__0jEUH","regular":"Badge_regular__iknjR"};